import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchListHistoryRequest } from "../store/actions";

export function useGetHistory() {
  const dispatch = useDispatch();
  const { loading, data, lastPage, params } = useSelector(
    (state: any) => state.Ingredients.history || {}
  );

  const fetchData = (params: any) => {
    dispatch(fetchListHistoryRequest({ page: params.page, page_size: 10 }));
  };

  useEffect(() => {
    fetchData({
      page: 1,
    });
  }, []);

  const reLoadList = (data: any) => {
    fetchData(data);
  };

  const loadMore = useCallback(() => {
    if (loading) {
      return;
    }
    params.page = params?.page + 1;
    fetchData(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.page, loading]);

  return {
    loading,
    data,
    reLoadList,
    loadMore,
    lastPage,
    params,
  };
}
